export default{
    lista:{
        method:'get',
        url:'taxa/lista?id={id}'
    },
    cadastra:{
        method:'post',
        url:'taxa/cadastro'
    },
    delete:{
        method:'delete',
        url:'taxa/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'taxa/editar{/id}'
    },
    update:{
        method:'post',
        url:'taxa/update'
    }
}